<template>
  <authentication-layout>
    <header slot="form-header" class="header">
      <h2 class="title">Faça seu cadastro e inicie seu licenciamento sem sair de casa.</h2>
    </header>

    <template slot="form-content">
      <v-card class="elevation-0">
        <v-form v-model="valid">
          <v-text-field
            v-model="cpfcnpj"
            label="CPF"
            mask="###.###.###-##"
            :rules="[validationRules.required, validationRules.cpf]"
            type="text"
          />

          <v-text-field
            name="fullname"
            v-model="fullName"
            label="Nome Completo"
            :rules="[validationRules.required]"
            type="text"
          />

          <v-text-field
            v-model="email"
            label="E-mail"
            :rules="[validationRules.required, validationRules.email]"
            type="email"
          />

          <v-text-field
            v-model="cellphone"
            label="Telefone"
            :rules="[validationRules.required]"
            type="text"
            mask="(##)#####-####">
          </v-text-field>

          <v-text-field
            v-model="password"
            :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
            :append-icon-cb="() => (e1 = !e1)"
            :type="e1 ? 'password' : 'text'"
            :rules="[validationRules.required]"
            name="password"
            label="Senha"
            hint="Mínimo de 8 caracteres"
            min="8"
          />

          <v-layout justify-start>
            <v-checkbox
              v-model="agreed"
              required
              :rules="[(v) => v || 'Este campo é obrigatório']"
              :error-messages="[]"
              class="mb-2"
            >
              <div slot="label">
                Eu li e aceito os &nbsp;
                <strong
                  style="margin-left: -6px"
                  class="blue--text"
                  @click.stop="isLegalTermsVisible = true"
                >
                  termos legais
                </strong>
              </div>
            </v-checkbox>
          </v-layout>
        </v-form>

        <v-card-actions class="action">
          <vue-recaptcha
            ref="recaptcha"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired"
            size="invisible"
            sitekey="6Le_MHMUAAAAAAaHBrfhZeqdOs4is4Zp5Cwi4zhc"
          />
          <v-btn
            id="buttonsub"
            color="success"
            :disabled="!valid"
            @click="createUser"
          >
            Registrar
          </v-btn>
        </v-card-actions>
      </v-card>
      <legal-terms-dialog
        :isLegalTermsVisible="isLegalTermsVisible"
        @toggleLegalTerms="isLegalTermsVisible = $event"
        mode="read"
      />
    </template>

    <template slot="navigation">
      <v-btn flat small color="primary" class="link" :to="'/requerente/conta/entrar'">
        <v-icon left>mdi-account-circle</v-icon>
        <span class="text">Voltar ao login</span>
      </v-btn>
    </template>
  </authentication-layout>
</template>


<script>
import AuthenticationLayout from '@/layouts/AuthenticationLayout';
import LegalTermsDialog from '@/components/legal_terms/LegalTermsDialog';
import UserService from '@/services/UserService';
import validationRules from '@/mixins/validation-rules';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'FormSignup',
  components: {
    AuthenticationLayout,
    LegalTermsDialog,
    VueRecaptcha,
  },
  mixins: [validationRules],
  data: () => ({
    e1: true,
    agreed: false,
    cellphone: '',
    cpfcnpj: '',
    fullName: '',
    email: '',
    isLegalTermsVisible: false,
    password: '',
    valid: false,
    validationRules,
  }),
  methods: {
    onCaptchaVerified(recaptchaToken) {
      const userParams = {
        name: this.fullName,
        cpf: this.cpfcnpj,
        cellphone: this.cellphone,
        email: this.email,
        password: this.password,
        recaptcha: recaptchaToken,
      };
      UserService
        .createUser(userParams)
        .then(() => {
          this.$store.dispatch('setUserSignUpData', userParams);
          this.$router.push('cadastrar/sucesso');
        })
        .catch((responseError) => {
          this.$swal({
            type: 'error',
            title: 'Erro',
            html: responseError.response.data.join('<br/>'),
          });
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
          this.$refs.recaptcha.reset();
        });
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
      this.$store.dispatch('setLoadingDialog', false);
    },
    createUser() {
      this.$store.dispatch('setLoadingDialog', true);
      this.$refs.recaptcha.execute();
    },
  },
};
</script>
